<template>
    <div class="packing-list print-overlay">
        <el-dialog :visible.sync="dialogVisible" :show-close="false" top="64px" :append-to-body="true" custom-class="print-overlay__dialog">
            <div class="print-overlay__content">
                <div class="print-overlay__head no-print">
                    <span class="bold-label">Druckvorschau</span>
                    <div class="print-overlay__close" @click="closeClickHandler">
                        <Icon><IconClose/></Icon>
                    </div>
                </div>
                <div class="packing-list__main">
                    <Loader v-if="loading"/>
                    <template v-else-if="packingInfo">
                        <div class="packing-list__top ui-spread-center-vertically">
                            <div>
                                <div class="h1">Packliste</div>
                                <div class="copy-light">Weitere Infos in der <a href="https://infothek.oeamtc.at/thema/reiseplanung/oeamtc-reise-infoset-16185040#welche-packhilfen-stehen-fuer-das-reise-infoset-zur-verfuegung-30234782" target="_blank">Infothek</a>.</div>
                            </div>
                            <SmrButton custom-class="print-preview__button no-print" @click.native="printClickHandler" size="medium">Drucken</SmrButton>
                        </div>
                        <div class="packing-list__infos">
                            <div class="packing-list__item" v-for="(infoItem, index) in packingInfo" :key="index">
                                <div class="packing-list__item__head ui-center-vertically">
                                    <div class="packing-list__item__indicator" :style="`${infoItem[0].colourCode ? `background-color: ${infoItem[0].colourCode}` : ''}`"></div>
                                    <div class="h5">{{ MAP_TYPE_LABELS[index] }}</div>
                                </div>
                                <div class="packing-list__item__body copy">
                                    <div v-for="infoItemEntry in infoItem" :key="infoItemEntry.id">{{ infoItemEntry.shortCode }} – {{ infoItemEntry.name }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else class="packing-list__empty">
                        <Icon class="packing-list__empty__icon" :size="32">
                            <IconPackingList />
                        </Icon>
                        <template v-if="error">
                            <div class="h2-light">Leider konnten auf Grund eines technischen Problems keine Ergebnisse gefunden werden.</div>
                            <div class="copy-light">Bitte versuchen sie es zu einem späteren Zeitpunkt erneut.</div>
                        </template>
                        <template v-else>
                            <div class="h2-light">Kein Reise-Infoset verfügbar</div>
                            <div class="copy-light">Informationen zu Einreisebestimmungen, Anreise, Sehenswertem u.v.m. gibt es in der <a href="https://infothek.oeamtc.at/laenderinfo/" target="_blank">ÖAMTC Länder-Info</a>.</div>
                    </template>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import eventBus from '@/utils/event-bus';
import * as api from '@/api';
import Icon from '@/components/Icon.vue'
import IconClose from '@/components/icons/IconClose.vue'
import IconPackingList from '@components/icons/IconPackingList.vue';
import SmrButton from '@/components/SmrButton.vue'
import Loader from '@/components/Loader.vue'

export default {
    components: {
        Icon,
        IconClose,
        IconPackingList,
        SmrButton,
        Loader,
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            dialogVisible: false,
            loading: false,
            error: false,
            packingInfo: false,
            MAP_TYPE_LABELS: {
                TRAVEL_INFO_KIT: 'Allgemeines',
                TRAVEL_MAP: 'Reisekarten',
                VACATION_GUIDE_CITY: 'Urlaubsführer Stadt',
                VACATION_GUIDE_REGION: 'Urlaubsführer Region',
                TRAVEL_INFO: 'ÖAMTC Reise-Infos',
            }
        }
    },
    computed: {
        ...mapGetters(['routeCorridor', 'routeCorridorRadius', 'routeWaypoints']),
    },
    mounted() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        closeClickHandler() {
            eventBus.$emit('itemClosed');
            this.closeDialog();
        },
        showPackingListHandler(e) {
            this.packingInfo = false
            this.error = false
            const params = this.createPackingParams(e)
            this.getPackingListData(params)
            this.showDialog()
        },
        printClickHandler() {
            window.print()
        },
        addListeners() {
            eventBus.$on('showPackingList', this.showPackingListHandler);
        },
        removeListeners() {
            eventBus.$off('showPackingList', this.showPackingListHandler);
        },
        closeDialog() {
            document.body.classList.remove('print-route')
            this.dialogVisible = false;
        },
        showDialog() {
            document.body.classList.add('print-route')
            this.dialogVisible = true;
        },
        createPackingParams(data) {
            if(data.route) {
                return {
                    geographic: {
                        corridor: {
                            polylineWKT: this.routeCorridor,
                            radius: this.routeCorridorRadius || 1000,
                        }
                    },
                    waypoint: {
                        waypoints: this.routeWaypoints.map(point => {
                            return {
                            coordinate: point.coordinate
                            }
                        })
                    }
                }
            }
            if(data.location) {
                return {
                    waypoint: {
                        waypoints: [
                            {
                                coordinate: {
                                    longitude: data.location.lon,
                                    latitude: data.location.lat,
                                }
                            }
                        ]
                    }
                }
            }
            return false
        },
        async getPackingListData(params) {
            if(!params) return
            this.loading = true;
            try {
                const response = await api.packingList.search(params)
                if(response.data.items && response.data.items.length) {
                    const items = response.data.items
                    this.packingInfo = {}
                    for(const i in this.MAP_TYPE_LABELS) {
                        if(items.filter(item => item.mapType === i).length) {
                            this.packingInfo[i] = items.filter(item => item.mapType === i)
                        }
                    }
                }
                this.loading = false
            } catch(error) {
                console.error(error)
                this.loading = false;
                this.error = true;
            }
        }
    }
}
</script>

<style lang="scss">
.packing-list {
    &__main {
        padding: 24px 30px 30px;
    }

    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        max-width: 260px;
        margin: 0 auto;
        text-align: center;
        padding: 100px 0;

        &__icon {
            color: $color-black-04;
        }
    }

    &__infos {
        margin-top: 24px;
    }

    &__item {
        &:not(:last-child) {
            margin-bottom: 20px;
        }
        &__head {
            gap: 16px;
            margin-bottom: 4px;
        }
        &__indicator {
            width: 12px;
            height: 12px;
            border-radius: 2px;
            background: $color-yellow;
        }
        &__body {
            padding-left: calc(12px + 16px);
        }
    }
}
</style>